<template>
  <b-navbar toggleable="lg" type="" variant="faded">
    <div class="container">
      <b-navbar-brand :to="'/'" :title="data.name">
        <img :src="app_logo" class="brand-logo" :alt="data.name" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse">
        <template #default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="loggedInUser" class="text-center">
          <b-nav-item v-if="!loggedInUser.is_staff">
            <router-link class="nav-link" to="/santri" role="button" title="Santri">
              <i class="fa fa-users"></i> Santri
            </router-link>
          </b-nav-item>
          <b-nav-item v-if="!loggedInUser.is_staff">
            <router-link class="nav-link" to="/santri/absensi" role="button" title="Absensi">
              <i class="fa fa-calendar-check"></i> Absensi
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" :to="'/ppob?token=' + token" role="button" title="PPOB">
              <i class="fa fa-mobile"></i> PPOB
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link
              class="nav-link"
              to="/page/jadwal-shalat"
              role="button"
              title="Jadwal Shalat"
            >
              <i class="fa fa-clock"></i> Jadwal Shalat
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="/page/hadits" role="button" title="Hadits">
              <i class="fa fa-book"></i> Hadits
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="/page/al-quran" role="button" title="Al-Quran">
              <i class="fa fa-book-open"></i> Al-Quran
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link
              class="nav-link"
              to="/page/surat-pendek"
              role="button"
              title="Surat Pendek"
            >
              <i class="fa fa-book-open"></i> Surat Pendek
            </router-link>
          </b-nav-item>
          <b-nav-item v-if="loggedInUser.is_staff">
            <router-link class="nav-link" to="/admin/home" role="button" title="Dashboard">
              <i class="fas fa-tachometer-alt"></i> Dashboard
            </router-link>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav v-else class="text-center">
          <b-nav-item>
            <router-link to="/" title="home" class="nav-link">
              <i class="fa fa-home"></i> Home</router-link
            >
          </b-nav-item>
          <b-nav-item>
            <router-link
              class="nav-link"
              to="/page/jadwal-shalat"
              role="button"
              title="Jadwal Shalat"
            >
              <i class="fa fa-clock"></i> Jadwal Shalat
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="/page/hadits" role="button" title="Hadits">
              <i class="fa fa-book"></i> Hadits
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="/page/al-quran" role="button" title="Al-Quran">
              <i class="fa fa-book-open"></i> Al-Quran
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link
              class="nav-link"
              to="/page/surat-pendek"
              role="button"
              title="Surat Pendek"
            >
              <i class="fa fa-book-open"></i> Surat Pendek
            </router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="/auth/login" role="button" title="Login">
              <i class="fa fa-sign-in-alt"></i> Masuk
            </router-link>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="loggedInUser" title="Instagram" target="_blank" @click="logout">
            <i class="fa fa-sign-out-alt"></i> Keluar
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
// Utilities
import { mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      app_logo: process.env.appLogo,
      title: 'SiTrendi - Sistem Pesantren Digital',
      notifications: [{ href: '/profile', text: 'Lengkapi profile anda' }],
      responsive: true,
      disableNotification: true,
      data: '',
      token: '',
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser']),
  },
  mounted() {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    this.token = this.loggedInUser?.remember_token
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClick() {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onResponsiveInverted() {
      this.responsive = window.innerWidth < 991
    },
    logout() {
      this.$swal
        .fire({
          title: 'Kamu yakin akan keluar ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('/logout')
              .then((response) => {
                this.$auth.logout()
                this.$swal.fire({
                  icon: 'success',
                  title: 'Anda telah berhasil keluar',
                  showConfirmButton: false,
                  timer: 1500,
                })
                this.$router.push({ path: '/login' })
              })
              .catch((res) => {
                this.data = null
                this.$auth.logout()
                this.$swal.fire({
                  icon: 'warning',
                  title: 'Sesi anda telah berakhir, silahkan masuk kembali',
                  showConfirmButton: false,
                  timer: 1500,
                })
                this.$router.push({ path: '/login' })
              })
          }
        })
    },
  },
}
</script>

<style>
/* Fix coming in v2.0.8 */
#core-app-bar {
  width: auto;
}
.brand-logo {
  width: 180px;
}
#core-app-bar a {
  text-decoration: none;
}
</style>
